module.exports = __webpack_public_path__ + "static/media/icon_warning_rectangle.52f1eff4.svg";